<template>
  <div class="create-profile-wrapper">
    <div class="close" @click="router.go(-1)">
      <img src="/icons/x-icon.png"/>
    </div>
    <div class="create-profile-title">
      Login to Artfield
    </div>
    <div class="inputs-wrapper">
      <div class="input-wrapper">
        <div class="input-label">Email address</div>
        <input
            type="email"
            v-model="emailRef"
            class="create-input"
            placeholder="Email address *"
            @keyup.enter="submitForm"
        />
        <div v-if="!$v.emailRef.required && $v.emailRef.$error" class="error-message">
          Email is required
        </div>
        <div v-if="!$v.emailRef.email && $v.emailRef.$error" class="error-message">
          Must be a valid email
        </div>
      </div>
      <div class="input-wrapper">
        <div class="input-label">Password</div>
        <input
            type="password"
            v-model="password"
            class="create-input"
            placeholder="Password *"
            @keyup.enter="submitForm"
        />
        <div v-if="!$v.password.required && $v.password.$error" class="error-message">
          Password is required
        </div>
        <div class="password-error uppercase" v-if="loginError">
          Password is wrong
        </div>
      </div>
      <div class="w-full flex justify-end">
        <div class="forgot-password" @click="showPopup">Forgot your password?</div>
      </div>
      <div class="w-full flex justify-center items-center next-wrapper">
        <div class="create-button" @click="submitForm">Log in</div>
      </div>
    </div>
    <Popup v-if="showForgotPopup" @close="closePopup">
      <ForgotPasswordPopup @close="closePopup"></ForgotPasswordPopup>
    </Popup>
    <Popup v-if="showForgotPopup2 && tokenVal" @close="closePopup2">
      <ChangePasswordPopup :token="tokenVal" @close="closePopup2"></ChangePasswordPopup>
    </Popup>
  </div>
</template>

<script setup lang="ts">
import {nextTick, onMounted, ref, watch} from 'vue';
import useVuelidate from '@vuelidate/core';
import {required, email as emailValidator} from '@vuelidate/validators';
import {useUserStore} from '@/composables/useUserStore';

import * as pkg from 'vue-toastification';
const { useToast } = pkg;import {useRouter, useRoute} from "vue-router";
import Popup from "~/components/Popup.vue";
import ForgotPasswordPopup from "~/components/login/ForgotPasswordPopup.vue";
import ChangePasswordPopup from "~/components/login/ChangePasswordPopup.vue";
import {checkPassToken} from "~/api/userApi";
const { token, login } = useUserStore();
const router = useRouter();
const route = useRoute();
const toast = useToast();
const emailRef = ref('');
const password = ref('');
const loginError = ref(false);
const showForgotPopup = ref(false);

const showForgotPopup2 = ref(false);
const tokenVal = ref('');

onMounted(async () => {
  const token = (route.params.token || route.query.token) as string; // Get the token from the URL
  if (token) {
    tokenVal.value = token;
    try {
      const isValid = await checkPassToken(token);
      console.log('isvalid', isValid);
      if (!isValid) {
        await router.push('/login'); // Redirect to login if the token is invalid
      } else {
        await nextTick(() => {
          showForgotPopup2.value = true;
        })
      }
    } catch (error) {
      console.error('Error validating token:', error);
      await router.push('/login'); // Handle errors and redirect to login
    }
  }
});
const closePopup2 = () => {
  showForgotPopup2.value = false;
}
const showPopup2 = () => {
  showForgotPopup2.value = true;
}
const closePopup = () => {
  showForgotPopup.value = false;
}
const showPopup = () => {
  showForgotPopup.value = true;
}

watch(loginError, () => {
  if (loginError.value) {
    setTimeout(() => {
      loginError.value = false;
    }, 5000);
  }
})

const rules = {
  emailRef: {required, email: emailValidator},
  password: {required},
};

const $v = useVuelidate(rules, {emailRef, password});

const submitForm = async () => {
  $v.value.$touch();
  if ($v.value.$invalid) {
    return;
  }

  try {
    const result = await login(emailRef.value, password.value);
    if (result) {
      loginError.value = false;
      console.log(token.value);
      toast.success("Login successful");
      await router.push('/field/feed');
    } else {
      loginError.value = true;
      toast.error("Login failed");
    }
  } catch (error) {
    loginError.value = true;
    toast.error("Login failed");
  }
};
</script>

<style scoped>
.forgot-password {
  font-size: 14px;
  font-weight: 400;
  color: rgba(255, 255, 255, .5);
  text-decoration: underline;
  cursor: pointer;
}
.next-wrapper {
  padding: 40px 0 20px 0;
}

.password-error {
  color: rgba(255, 255, 255, 1);
  font-size: 8px;
}

.inputs-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-wrapper {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.create-input::placeholder {
  color: rgba(255, 255, 255, 0.5);
}

.input-label {
  font-size: 14px;
}

.create-input {
  background: transparent;
  border: 1px solid white;
  border-radius: 10px;
  padding: 10px;
}

.create-select {
  background: transparent;
  border: 1px solid white;
  border-radius: 10px;
  padding: 10px;
}

.profile-photo-wrapper {
  width: 90px;
  height: 90px;
}

.profile-photo-content img {
  width: 100%;
}

.photo-title {
  font-size: 14px;
  padding-bottom: 5px;
}

.create-button.upload {
  height: 40px;
  line-height: 40px;
  border-radius: 20px;
  padding: 0 20px;
  border: 1px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
}

.create-button {
  line-height: 30px;
  border-radius: 20px;
  padding: 0 20px;
  border: 1px solid white;
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  width: 200px;
  cursor: pointer;
}

.profile-photo-content {
  padding: 5px;
  border-radius: 90px;
  width: 100%;
  border: 1px solid white;
}

.profile-photo {
  padding-bottom: 20px;
  position: relative;
}

.create-profile-wrapper {
  width: 650px;
  color: white;
  padding: 40px 40px 0 40px;
  position: relative;
  border: 1px solid white;
  border-radius: 10px;
}

.create-profile-title {
  font-size: 28px;
  color: white;
  text-align: center;
  margin-bottom: 35px;
}

.create-profile-wrapper .close img {
  width: 100%;
}

.create-profile-wrapper .close {
  position: absolute;
  top: 40px;
  right: 40px;
  width: 30px;
  height: 30px;
}

.error-message {
  color: red;
  font-size: 10px;
}

@media (max-width: 768px) {
  .create-profile-wrapper {
    width: calc(100% - 32px) !important;
    max-width: none;
    padding: 24px 20px 0 20px !important;
    margin: 0 16px;
  }

  .create-profile-wrapper .close {
    top: 20px !important;
    right: 20px !important;
    width: 24px !important;
    height: 24px !important;
  }

  .create-profile-title {
    font-size: 22px !important;
    margin-bottom: 24px !important;
    padding-right: 32px;
  }

  .inputs-wrapper {
    gap: 16px;
  }

  .input-wrapper {
    gap: 8px;
  }

  .input-label {
    font-size: 12px;
  }

  .create-input {
    padding: 14px 12px;
    font-size: 16px; /* Prevents zoom on iOS */
  }

  .forgot-password {
    font-size: 12px;
  }

  .next-wrapper {
    padding: 24px 0 16px 0;
  }

  .create-button {
    width: 100% !important;
    max-width: 280px;
    padding: 14px 24px !important;
    font-size: 14px;
  }
}
</style>
